import { NgModule } from '@angular/core';
import { AgGridKeyboardNavigationDirective } from '@app/shared/common/ag-grid-navigation/keyboard-navigation.directive';
import { ThrottleClickDirective } from '../common/throttle-click.directive';

import {
  XviDropdownDirective,
  XVIDropdownMenuDirective,
} from './dropdown.directive';

@NgModule({
  imports: [],
  declarations: [
    XviDropdownDirective,
    XVIDropdownMenuDirective,
    ThrottleClickDirective,
    AgGridKeyboardNavigationDirective,
  ],
  providers: [],
  exports: [
    XviDropdownDirective,
    XVIDropdownMenuDirective,
    ThrottleClickDirective,
    AgGridKeyboardNavigationDirective,
  ],
})
export class XviDirectivesModule {}
